<template>
  <router-view/>
  <InstallPrompt/>
</template>

<script>
import api from './services/api.js'
import InstallPrompt from './components/InstallPrompt.vue'

export default {
  data() {
    return {
      user: this.$store.getters.USER,
      userData: this.$store.getters.USERDATA,
      interval: null,
      i: 0,
      AUDIO: {
        BALANCE: new Audio(require('@/assets/media/money.mp3'))
      },
    }
  },
  components: {
    InstallPrompt
    },
  beforeDestroy() {
    
  },
  created() {
    if (localStorage.getItem('user')) {
      this.$store.commit('SET_USER', JSON.parse(localStorage.getItem('user')))
      this.user = this.$store.getters.USER
      this.userInfo()
      
      // Не инициализируем push автоматически при загрузке!
      // Push-уведомления включаются только по действию пользователя в Header.vue
      
      for (let a = 0; a < 10; a++) {
      try{
        clearTimeout(a)
      }
      catch (e) {
        //lo
      }
    }
    }
  },
  mounted() {
  },
  methods: {
    exitApp () {
      localStorage.clear()
      location.href ='/'
    },
    userInfo () {
      api.post('/api/userinfo', {id: this.user.id}).then((res) => {
        if (!res.data.error) {
          if (this.i !== 0 && this.userData.balance < res.data.userData.balance) {
            this.AUDIO.BALANCE.play()
          }
          this.userData = res.data.userData
          this.$store.commit('SET_USERDATA', this.userData)
        }
        if (res.data.error && res.data.message === 'unlogin') {
          this.$store.commit('SET_USER', {auth: false, token: false})
          this.$store.commit('SET_USERDATA', {})
          localStorage.clear()
          location.reload()
        }
        setTimeout(() => {
          this.i = 1
          this.userInfo()
        }, 10000)
      })
    }
  }
}
</script>

<style>
.bold {
  font-weight: 900 !important;
}
.cursor {
  cursor:help;
}
.cursor-pointer {
  cursor: pointer;
}

/* ===== GLOBAL SCROLLBAR STYLES ===== */

/* WebKit scrollbar (Chrome, Safari, Edge, Opera) */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(30, 41, 59, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(99, 102, 241, 0.4);
  border-radius: 4px;
  transition: all 0.2s ease;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(99, 102, 241, 0.7);
}

::-webkit-scrollbar-corner {
  background: rgba(30, 41, 59, 0.5);
}

/* Firefox scrollbar */
* {
  scrollbar-width: thin;
  scrollbar-color: rgba(99, 102, 241, 0.4) rgba(30, 41, 59, 0.5);
}

/* Dark theme scrollbar */
body.dark-mode ::-webkit-scrollbar-track {
  background: rgba(15, 23, 42, 0.8);
}

body.dark-mode ::-webkit-scrollbar-thumb {
  background: rgba(99, 102, 241, 0.5);
}

body.dark-mode ::-webkit-scrollbar-thumb:hover {
  background: rgba(99, 102, 241, 0.8);
}

body.dark-mode ::-webkit-scrollbar-corner {
  background: rgba(15, 23, 42, 0.8);
}

body.dark-mode {
  scrollbar-color: rgba(99, 102, 241, 0.5) rgba(15, 23, 42, 0.8);
}

/* Light theme scrollbar */
body:not(.dark-mode) ::-webkit-scrollbar-track {
  background: rgba(241, 245, 249, 0.8);
}

body:not(.dark-mode) ::-webkit-scrollbar-thumb {
  background: rgba(99, 102, 241, 0.3);
}

body:not(.dark-mode) ::-webkit-scrollbar-thumb:hover {
  background: rgba(99, 102, 241, 0.6);
}

body:not(.dark-mode) ::-webkit-scrollbar-corner {
  background: rgba(241, 245, 249, 0.8);
}

body:not(.dark-mode) {
  scrollbar-color: rgba(99, 102, 241, 0.3) rgba(241, 245, 249, 0.8);
}

/* Specific scrollbar styles for tables */
.table-responsive::-webkit-scrollbar {
  height: 6px;
}

.table-responsive::-webkit-scrollbar-track {
  background: rgba(30, 41, 59, 0.3);
}

.table-responsive::-webkit-scrollbar-thumb {
  background: rgba(99, 102, 241, 0.4);
  border-radius: 3px;
}

/* Specific scrollbar styles for dropdown menus */
.dropdown-menu::-webkit-scrollbar {
  width: 6px;
}

.dropdown-menu::-webkit-scrollbar-track {
  background: rgba(30, 41, 59, 0.3);
}

.dropdown-menu::-webkit-scrollbar-thumb {
  background: rgba(99, 102, 241, 0.4);
  border-radius: 3px;
}

/* Specific scrollbar styles for modal content */
.modal-content::-webkit-scrollbar {
  width: 6px;
}

.modal-content::-webkit-scrollbar-track {
  background: rgba(30, 41, 59, 0.3);
}

.modal-content::-webkit-scrollbar-thumb {
  background: rgba(99, 102, 241, 0.4);
  border-radius: 3px;
}

/* Hide scrollbar but keep functionality for specific elements */
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>
